const es = {
  // Nav
  nav_home: "Inicio",
  nav_services: "Servicios",
  nav_about: "Nosotros",
  nav_pricing: "Precios",
  nav_reviews: "Reseñas",
  nav_faq: "Preguntas",
  nav_contact: "Contacto",
  nav_cta: "Cotización Gratis",

  // Hero
  hero_badge: "MÁS DE 500 CLIENTES NOS CONFÍAN",
  hero_headline: "Servicios de Limpieza Profesional en los que Puedes Confiar",
  hero_subheadline: "Limpieza residencial y comercial con resultados de calidad premium. Asegurados, confiables y siempre puntuales.",
  hero_cta_primary: "Cotización Gratis",
  hero_cta_secondary: "Reservar Ahora",
  hero_trust_1: "100% Satisfacción",
  hero_trust_2: "Totalmente Asegurados",
  hero_trust_3: "Calificación 5 Estrellas",
  hero_rating: "4.9/5 de más de 247 reseñas",

  // Services Preview
  services_label: "NUESTROS SERVICIOS",
  services_headline: "Soluciones Completas de Limpieza",
  services_sub: "Desde hogares acogedores hasta grandes espacios comerciales, entregamos resultados impecables.",
  services_learn_more: "Ver Más",
  service_residential: "Limpieza Residencial",
  service_residential_desc: "Limpieza exhaustiva de arriba a abajo para tu hogar usando productos ecológicos.",
  service_commercial: "Limpieza Comercial",
  service_commercial_desc: "Limpieza profesional de oficinas y espacios comerciales que mantiene tu negocio brillante.",
  service_deep: "Limpieza Profunda",
  service_deep_desc: "Limpieza intensiva que llega a cada rincón — perfecta para limpiezas estacionales o por primera vez.",
  service_moveinout: "Mudanza Entrada / Salida",
  service_moveinout_desc: "Haz tu mudanza sin estrés con nuestra limpieza integral de entrada y salida.",
  service_airbnb: "Limpieza Airbnb",
  service_airbnb_desc: "Cambios rápidos y confiables que mantienen a tus huéspedes felices y tus calificaciones altas.",
  service_office: "Limpieza de Oficinas",
  service_office_desc: "Una oficina limpia aumenta la productividad. Lo manejamos para que tu equipo pueda concentrarse.",

  // Benefits
  benefits_label: "¿POR QUÉ ELEGIRNOS?",
  benefits_headline: "Calidad Premium, Siempre",
  benefits_text: "Combinamos experiencia profesional con cuidado genuino por tu hogar y negocio. Nuestro equipo tiene verificación de antecedentes, está capacitado y completamente asegurado.",
  benefits_cta: "Comenzar",
  benefit_reliable: "Equipo Confiable",
  benefit_reliable_desc: "Profesionales con antecedentes verificados que llegan puntualmente, siempre.",
  benefit_eco: "Productos Ecológicos",
  benefit_eco_desc: "Usamos productos seguros y de alta calidad que protegen a tu familia, mascotas y el medio ambiente.",
  benefit_flexible: "Horario Flexible",
  benefit_flexible_desc: "Reserva cuando te convenga — mañanas, tardes, fines de semana. Nos adaptamos a tu agenda.",
  benefit_affordable: "Precios Accesibles",
  benefit_affordable_desc: "Precios transparentes y competitivos sin cargos ocultos. Servicio premium a tarifas justas.",
  benefit_guaranteed: "Satisfacción Garantizada",
  benefit_guaranteed_desc: "¿No estás satisfecho? Regresamos a limpiar sin costo adicional. Tu satisfacción es nuestra promesa.",
  benefit_insured: "Totalmente Asegurados",
  benefit_insured_desc: "Tranquilidad total — estamos completamente licenciados, afianzados y asegurados para tu protección.",

  // Process
  process_label: "CÓMO FUNCIONA",
  process_headline: "Proceso de Reserva Simple",
  process_sub: "Obtén tu espacio limpiado profesionalmente en tres sencillos pasos.",
  process_step1_title: "Solicitar Cotización",
  process_step1_desc: "Llena nuestro formulario rápido y te responderemos con una cotización personalizada en horas.",
  process_step2_title: "Programar Servicio",
  process_step2_desc: "Elige fecha y hora que te convengan. Confirmaremos y enviaremos recordatorios.",
  process_step3_title: "Disfruta tu Espacio",
  process_step3_desc: "Nuestro equipo llega puntual, limpia a fondo y deja tu espacio impecable.",
  process_cta: "Reservar tu Servicio Ahora",

  // Stats
  stat_clients: "Clientes Felices",
  stat_years: "Años de Experiencia",
  stat_satisfaction: "Tasa de Satisfacción",
  stat_support: "Soporte Disponible",

  // Testimonials
  testimonials_label: "RESEÑAS DE CLIENTES",
  testimonials_headline: "Lo Que Dicen Nuestros Clientes",
  testimonials_sub: "Reseñas reales de personas que confían en Prime Shine WA.",

  // CTA Section
  cta_headline: "¿Listo para un Espacio Impecable?",
  cta_sub: "Reserva tu servicio de limpieza profesional hoy. Sin compromiso.",
  cta_primary: "Cotización Gratis",
  cta_secondary: "Llamar Ahora",
  cta_note: "Sin compromiso • Consulta gratuita",

  // Pricing
  pricing_label: "PRECIOS",
  pricing_headline: "Precios Simples y Transparentes",
  pricing_sub: "Sin cargos ocultos. Elige el plan que se adapte a tus necesidades o solicita una cotización personalizada.",
  pricing_popular: "Más Popular",
  pricing_cta: "Comenzar",
  pricing_custom_cta: "Solicitar Cotización",
  pricing_custom_headline: "¿Necesitas algo específico?",
  pricing_custom_text: "Espacios comerciales, hogares grandes o servicios recurrentes — ofrecemos cotizaciones personalizadas.",

  // FAQ
  faq_label: "PREGUNTAS FRECUENTES",
  faq_headline: "Preguntas Frecuentes",
  faq_sub: "Todo lo que necesitas saber sobre nuestros servicios de limpieza.",

  // Contact
  contact_label: "CONTÁCTANOS",
  contact_headline: "Comencemos",
  contact_sub: "¿Listo para un espacio más limpio? Comunícate y te responderemos en pocas horas.",
  contact_name: "Nombre Completo",
  contact_email: "Correo Electrónico",
  contact_phone: "Número de Teléfono",
  contact_service: "Tipo de Servicio",
  contact_message: "Mensaje",
  contact_submit: "Enviar Mensaje",
  contact_submitting: "Enviando...",
  contact_success: "¡Mensaje enviado! Nos pondremos en contacto pronto.",
  contact_whatsapp: "Chatear en WhatsApp",
  contact_area: "Área de Servicio",
  contact_area_value: "Área Metropolitana de Seattle, WA",
  contact_hours: "Lun–Vie: 8am–6pm | Sáb: 9am–4pm",

  // Footer
  footer_desc: "Servicios de limpieza profesional premium para hogares, oficinas y alquileres temporales en Washington.",
  footer_quick_links: "Enlaces Rápidos",
  footer_services: "Servicios",
  footer_contact: "Contáctanos",
  footer_newsletter: "Mantente Informado",
  footer_newsletter_placeholder: "Tu correo electrónico",
  footer_newsletter_cta: "Suscribirse",
  footer_copyright: "© 2026 Prime Shine WA. Todos los derechos reservados.",
  footer_privacy: "Política de Privacidad",
  footer_terms: "Términos de Servicio",

  // About
  about_label: "SOBRE NOSOTROS",
  about_headline: "Tu Socio de Limpieza de Confianza",
  about_story_label: "NUESTRA HISTORIA",
  about_story_headline: "Nacidos de una Pasión por la Limpieza",
  about_mission_label: "MISIÓN",
  about_mission_headline: "Nuestra Misión",
  about_vision_label: "VISIÓN",
  about_vision_headline: "Nuestra Visión",
  about_values_label: "NUESTROS VALORES",
  about_values_headline: "Lo Que Nos Impulsa",
  about_why_label: "¿POR QUÉ ELEGIRNOS?",
  about_why_headline: "La Diferencia Prime Shine",
  about_team_label: "NUESTRO EQUIPO",
  about_team_headline: "Conoce a los Profesionales",
};

export default es;
